import enMisc from './en.json'
const enMessages = {
    ...enMisc,
}

export default enMessages